export enum ToolStep {
  CAAS_INPUT = 'capital_asset_input',
  CAA_SCHEDULE = 'capital_asset_schedule',
  VARIANCE_ANALYSIS = 'variance_analysis_input',
  AGED_AR = 'aged_ar',
  INVESTMENT_SCHEDULE = 'investment_schedule_input',
  GENERAL_LEDGER = 'general_ledger_output',
  LOAN_AMORTIZATION = 'loan_amortization_input',
  BANK_RECON = 'bank_recon_selection',
  BR_INPUT = 'bank_recon_input',
  BR_ANALYSIS = 'bank_recon_analysis',
  BANK_STATEMENTS = 'bank_statements_to_tb_input',
  HST_GST = 'hst_analysis_input',
  LOAN_AMOR_INPUTS = 'loan_amortization_inputs',
  IS_ANALYSIS = 'investment_schedule_file_analysis',
  PAYROLL_ANALYSIS = 'payroll_input_request',
  PAYROLL_DATA = 'data_extraction',
  PAYROLL_INFO = 'payroll_input_information',
  PAYROLL_SELECTION = 'process_payroll_selection',
  USER_SELECTION = 'process_user_message',
  BANK_TO_TB = 'bank_to_tb_transactions',
  BAN_TO_TB_INPUT = 'bank_statements_to_tb_input',
  BANK_FINAL = 'final_tb_output_table',
  RENT_INPUT = 'rent_input_request',
  RENT_INFO = 'rent_input_information',
  RENT_SELECTION = 'request_selection',
  RENT_ROUTING = 'rent_process_routing',
  COVENANT_INPUT = 'covenant_input_request',
  COVENANT_INFO = 'covenant_input_information',
  DATA_EXTRACTION = 'data_extraction_from_files',
  INTEREST_INPUT = 'fetch_and_validate_tb_interest',
  INTEREST_PROCEED = 'proceed_interest_reasonability'
}
